import { cloneElement, isValidElement } from 'react';
import { useNavigate } from 'react-router-dom';

import CustomTour from 'components/shared/Tour/CustomTour';

import DelegationTasksIntro from '../DelegationTasksIntro/DelegationTasksIntro';

const renderIntro = ({ IntroComponent, consultant, onEndIntro }) => {
  if (!isValidElement(IntroComponent)) return IntroComponent;
  return cloneElement(IntroComponent, {
    onEndIntro: (...args) => {
      onEndIntro();
      IntroComponent.props?.onEndIntro?.(...args);
    },
    consultant
  });
};

const StepperOverlays = ({
  showTour,
  tourStepsConfig,
  onTourClose,
  showIntro,
  IntroComponent,
  consultant,
  wizardInstance,
  currentUserId,
  isAuthenticated,
  isAdmin,
  setShowIntro,
  startTourIfUnseen,
  showTasksIntro,
  setShowTasksIntro,
  assignedTasks,
  setNavigateToCode
}) => {
  const navigate = useNavigate();

  const isAssignedToOther =
    Boolean(wizardInstance?.assigned_to) && wizardInstance?.assigned_to !== currentUserId;

  const renderedIntro =
    showIntro && isAssignedToOther
      ? renderIntro({
          IntroComponent,
          consultant,
          onEndIntro: () => {
            setShowIntro(false);
            if (isAuthenticated) startTourIfUnseen();
          }
        })
      : null;

  const showDelegationIntro =
    isAssignedToOther && assignedTasks.length > 0 && !isAdmin && showTasksIntro;

  return (
    <>
      {showTour && <CustomTour steps={tourStepsConfig} onClose={onTourClose} />}
      {renderedIntro}
      {showDelegationIntro && (
        <DelegationTasksIntro
          title="Myriad Health"
          description="The most comprehensive practice management system ever created."
          onEndIntro={() => {
            setShowTasksIntro(false);
            if (isAuthenticated) startTourIfUnseen();
          }}
          onSkip={() => navigate('/portal')}
          navigateToTask={(code) => {
            setNavigateToCode(code);
            setShowTasksIntro(false);
            if (isAuthenticated) startTourIfUnseen();
          }}
          tasks={assignedTasks}
        />
      )}
    </>
  );
};

export default StepperOverlays;
